module.exports = __webpack_public_path__ + "a756608aa15b18c870019f328e93b4f4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-11.png
// module id = 2900
// module chunks = 0